<template>
<div class="item">
    <div class="pic-wrap" @click="_onPressToDetail">
        <img :src="item.cover_img">
    </div>
    <div class="body">
        <div class="item-info-wrap" @click="_onPressToDetail">
            <div class="title">
                <p>{{item.name}}</p>
                <span>免费</span>
            </div>
            <p class="time flex rcb">
                <span class="time-item">报名截止：{{item.expire_time_text}}</span>
            </p>
            <p class="time flex rcb">
                <span class="time-item">活动时间：{{item.start_time}} ～ {{item.end_time}}</span>
            </p>
            <div class="address">
                <p>{{item.area + ' ' + item.address}}</p>
                <span>{{item.num_text}}人已报名</span>
            </div>
        </div>
        <div class="btn-box">
            <div class="btn" @click="_onPressToNavigate('salonParticipant', {id: item.id, user_type: userType})" v-if="showUserList">查看报名列表</div>
            <div class="btn" @click="_onPressToDetail" v-if="!showUserList && status > 0">查看详情</div>
        </div>
    </div>
    <div class="type">
        <p>{{item.is_enroll_str}}</p>
    </div>
</div>
</template>

<script>
export default {
    name: "salonItem",
    props: ['item', 'type', 'status', 'userType'],
    computed: {
        showUserList() {
            let _isAgent = this.userType == this.Constants.USER_AGENT || this.userType == this.Constants.USER_MASTER;
            let _canSignIn = this.status == this.Constants.SALON_STATUS2 || this.status == this.Constants.SALON_STATUS3;
            return _isAgent && _canSignIn;
        }
    },
    data() {
        return {

        };
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        // 跳转详情
        _onPressToDetail() {
            let path = (this.status > 0 || this.userType == this.Constants.USER_STUDENT) ? 'salonDetail' : 'addSalon';
            this._onPressToNavigate('', path, {id: this.item.id, user_type: this.userType});
        }
    },
};
</script>

<style lang="less" scoped>
.item {
    position: relative;
    margin: 10px 15px;
    background: #ffffff;
    border-radius: 1.5rem;
    box-shadow: 0px 0px 5px 0px rgba(51, 51, 51, 0.10);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .pic-wrap {
        height: 20rem;
        overflow: hidden;
        background: #fdf8f0;

        >img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    >.body {
        padding: 10px;

        .title {
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 15px;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span {
                font-size: 18px;
                color: #F83535;
            }
        }

        .time {
            margin-top: 5px;
            font-size: 12px;
            color: #999;
        }

        .address {
            margin-top: 5px;
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 12px;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span {
                font-size: 12px;
                color: #333;
            }
        }

        .btn-box {
            margin-top: 10px;
        }

        .btn {
            margin-top: 10px;
            width: 100%;
            height: 35px;
            background: linear-gradient(225deg, #9cb2f4, #6472e8);
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            color: #fff;
        }
    }

    .type {
        position: absolute;
        width: 67px;
        height: 30px;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #7180eb;
        border-radius: 1.5rem 0;

        p {
            font-size: 12px;
            color: #fff;
        }
    }
}
</style>
